<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="hero">
          <h3 class="is-size-3">
            {{ groupName($route.params.group).name }}
          </h3>
        </div>
        <news-list :group="$route.params.group"/>
      </div>
    </section>
    <section class="section">
      <div class="hero">
        <div class="field">
          <router-link to="/">
              <button class="button is-link is-size-5 is-rounded">戻る</button>
            </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NewsList from '../../components/NewsList.vue'

export default {
  data: function(){
    return {

    }
  },
  components: {
    'news-list': NewsList
  },
  mounted(){
      this.$store.dispatch('users/getUserNewsList')
  },
  computed: {
    ...mapGetters({
      groupName: 'users/groupName',
    }),
  },
}
</script>

<style scoped>
  .hero {
    text-align: center
  }
</style>